import * as api from "services/api";

import history from "../../../../history";

import _ from "lodash";

export const ADD_TAG_COLOR = "[TAG COLOR CREATE] ADD_TAG_COLOR";
export const ADD_TAG_COLOR_SUCCESS =
  "[TAG COLOR CREATE] ADD_TAG_COLOR_SUCCESS";
export const ADD_TAG_COLOR_FAILED =
  "[TAG COLOR CREATE] ADD_TAG_COLOR_FAILED";

export const SET_VALUE = "[TAG COLOR CREATE] SET_VALUE";
export const CLEAR_VALUE = "[TAG COLOR CREATE] CLEAR_VALUE";

export function addTagColor() {
  return async (dispatch, getState) => {
    dispatch({
      type: ADD_TAG_COLOR
    });

    const { login, tagColorCreate } = getState();

    let { name, hexCode, active } = tagColorCreate;

    const errors = {};

    if (!name) errors.name = "Informe um nome";
    if (!hexCode) errors.hexCode = "Informe uma cor";

    dispatch(
      setValue({
        errors
      })
    );

    if (_.keys(errors).length > 0)
      return dispatch({ type: ADD_TAG_COLOR_FAILED });

    let response = await api.sendPost(
      "/TagColor",
      {
        name,
        hexCode,
        active
      },
      {
        Authorization: "Bearer " + login.token
      }
    );

    if (response.ok) {
      dispatch({
        type: ADD_TAG_COLOR_SUCCESS
      });

      dispatch(clearValue());

      history.push("/TagColor");
    } else {
      dispatch({ type: ADD_TAG_COLOR_FAILED });
    }
  };
}

export function setValue(payload) {
  return {
    type: SET_VALUE,
    payload
  };
}

export function clearValue() {
  return {
    type: CLEAR_VALUE
  };
}
